
// 参数名称	类型	默认值	描述信息
// color	string | Cesium.Color	new Cesium.Color(1.0, 1.0, 0.0, 0.5)	可选颜色
// alphaPower	number	1.5	可选透明度系数
// diffusePower	number	1.6	可选漫射系数
// isInner	boolean	false	可选渐变方向， true向内(周边浅中间深)、false外向(周边深中间浅)
// center	Cesium.Cartesian2	new Cesium.Cartesian2(0.5, 0.5)	可选渐变位置，默认在中心
/**
 * 渐变面
 */
class PolyGradientMaterialProperty {
    constructor(options) {
        this._definitionChanged = new Cesium.Event();
        this.color = options.color; //颜色
        this.alphaPower = options.alphaPower; //
        this.diffusePower = options.diffusePower; //
        this.isInner = options.isInner; //
        this.center = options.center; //
        this.globalAlpha=options.globalAlpha;
    };

    get isConstant() {
        return false;
    }

    get definitionChanged() {
        return this._definitionChanged;
    }

    getType(time) {
        return Cesium.Material.PolyGradientMaterial_Type;
    }

    getValue(time, result) {
        console.log("res----")
        if (!Cesium.defined(result)) {
            result = {};
        }
        result.color = Cesium.Property.getValueOrDefault(this.color, time, Cesium.Color.RED, result.color);
        result.alphaPower = Cesium.Property.getValueOrDefault(this.alphaPower, time, 1.5, result.alphaPower);
        result.diffusePower = Cesium.Property.getValueOrDefault(this.diffusePower, time, 1.6, result.diffusePower);
        result.isInner = Cesium.Property.getValueOrDefault(this.isInner, time, false, result.isInner);
        result.center = Cesium.Property.getValueOrDefault(this.center, time, new Cesium.Cartesian2(0.5, 0.5), result.center);
        result.globalAlpha = Cesium.Property.getValueOrDefault(this.globalAlpha, time, 1.0, result.globalAlpha);
        return result
    }

    equals(other) {
        return (this === other ||
            (other instanceof PolyGradientMaterialProperty &&
                Cesium.Property.equals(this.color, other.color) &&
                Cesium.Property.equals(this.alphaPower, other.alphaPower) &&
                Cesium.Property.equals(this.diffusePower, other.diffusePower) &&
                Cesium.Property.equals(this.isInner, other.isInner) &&
                Cesium.Property.equals(this.center, other.center)) &&
                Cesium.Property.equals(this.globalAlpha, other.globalAlpha)
        )
    }
}

Object.defineProperties(PolyGradientMaterialProperty.prototype, {
    color: Cesium.createPropertyDescriptor('color'),
    alphaPower: Cesium.createPropertyDescriptor('alphaPower'),
    diffusePower: Cesium.createPropertyDescriptor('diffusePower'),
    isInner: Cesium.createPropertyDescriptor('isInner'),
    center: Cesium.createPropertyDescriptor('center'),
    globalAlpha: Cesium.createPropertyDescriptor('globalAlpha'),
})

export default PolyGradientMaterialProperty;
